
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#e6e6e6"}}),_c('path',{attrs:{"d":"M44.22,81.54V62.81A16.27,16.27,0,0,1,60.49,46.54h43.87","transform":"translate(-.67 -.67)","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('polyline',{attrs:{"points":"91.69 33.87 103.69 45.87 91.94 57.62","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M104.36,68V86.76A16.28,16.28,0,0,1,88.08,103H44.22","transform":"translate(-.67 -.67)","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('polyline',{attrs:{"points":"55.55 114.37 43.55 102.37 55.3 90.62","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    